import { UIStoreMembershipProductView } from './UIStoreMembershipProductView.ts';
import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { setElementInnerHTML, setElementOnClick } from '../ui_utils/DomUtils.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { showSimpleDialog } from '../ui_popup/showSimpleDialog.ts';
import { TimeUtils } from '@colonist/utils';
import { GIFT_MEMBERSHIP_EXPIRY_YEARS } from '../../../../shared/store/BaseStoreItem.ts';
import { clientI18n } from '../ClientI18n.ts';
export class UIGiftedMembershipProductView extends UIStoreMembershipProductView {
    // eslint-disable-next-line class-methods-use-this
    addBestValueHint() {
    // no hint
    }
    constructor(container, storeState, giftedMembership, activateMembership, localizedProductData){
        const membershipProduct = ColonistMembershipProduct.getMembershipProduct(giftedMembership.membershipType);
        const canBeGifted = false;
        super(container, storeState, membershipProduct, undefined, localizedProductData);
        setElementInnerHTML(this.priceDiv, {
            key: getLengthText(membershipProduct.billedAnnually),
            options: {
                count: giftedMembership.periods
            }
        });
        const expiresAt = TimeUtils.addYears(TimeUtils.toDate(giftedMembership.giftedAt), GIFT_MEMBERSHIP_EXPIRY_YEARS);
        const expiry = TimeUtils.formatDateDistance(new Date(), expiresAt);
        const expiryFormatted = clientI18n.t(expiry.key, expiry.options);
        setElementInnerHTML(this.disclaimerText, {
            key: 'strings:storePage.sections.membership.giftWithExpiry',
            options: {
                expiry: expiryFormatted
            }
        });
        setElementInnerHTML(this.subscribeButtonText, {
            key: 'strings:storePage.sections.membership.action.activate'
        });
        setElementOnClick(this.productDiv, ()=>{
            AudioManager.play(AudioType.Click);
            showSimpleDialog({
                title: {
                    key: 'strings:storePage.sections.membership.activateConfirmation.title'
                },
                body: {
                    key: 'strings:storePage.sections.membership.activateConfirmation.body'
                },
                onConfirm: ()=>activateMembership(giftedMembership.id),
                showCancelBtn: true
            });
        });
    }
}
function getLengthText(year) {
    if (year) return 'strings:colonistCommon.dates.year';
    return 'strings:colonistCommon.dates.month';
}
